import { MDXProvider } from "@mdx-js/react";
import { MDXRemote } from "next-mdx-remote";
import { useEffect, useState } from "react";
import { convertMDX } from "utils/mdx";

// The table data is being rendered as raw HTML (rows) from the CMS.
// Since we are not able to use custom components directly for the table,
// we are styling it using CSS instead to achieve the desired appearance.

import styles from "@/styles/legal-rerfesh.module.scss";

const components = {
  h2: props => {
    return (
      <h2
        {...props}
        className="py-4 text-xl md:text-2xl 4xl:text-3xl font-medium text-onmoPrimaryBlack"
      >
        {props.children}
      </h2>
    );
  },
  blockquote: props => (
    <blockquote
      {...props}
      className="text-onmoGrey-medium font-normal text-base 4xl:text-xl"
    >
      {props.children}
    </blockquote>
  ),
  p: props => (
    <p {...props} className="pb-2 font-normal text-sm md:text-base 4xl:text-xl">
      {props.children}
    </p>
  ),
  h4: props => (
    <h4
      {...props}
      className="py-2 pt-4 text-sm md:text-base 4xl:text-2xl font-medium text-onmoText"
    >
      {props.children}
    </h4>
  ),
  a: props => (
    <a
      {...props}
      className="font-normal text-sm md:text-base 4xl:text-xl text-onmoPrimary underline"
    >
      {props.children}
    </a>
  ),
};

export function CustomMDX(props) {
  return (
    <MDXProvider components={components}>
      <MDXRemote {...props} />
    </MDXProvider>
  );
}

const Document = ({ data }) => {
  const [mdx, setMdx] = useState(null);

  useEffect(() => {
    (async () => {
      const mdxSource = await convertMDX(data ?? "", false);
      setMdx(mdxSource);
    })();
  }, [data]);

  return <div className={styles.mdx}>{mdx && <CustomMDX {...mdx} />}</div>;
};

export default Document;
